/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-10.
 * Form configuration for despachos
 */
import { SELECT, TEXT } from '../components/data-containers/formBuilder/types';
import { COLORS } from '../data/selects';

export const getConfig = (actions = {}) => {
    return {
        fields: [
            {
                fType: TEXT,
                key: 'status',
                floatingLabelFixed: true,
                floatingLabelText: 'Status',
                hintText: 'Nombre de Status',
                fullWidth: true
            },
            {
                fType: SELECT,
                key: 'color',
                floatingLabelText: 'Color',
                floatingLabelFixed: true,
                data: COLORS
            },

        ],
        rules: {
            status: [{ key: 'required', errorText: 'Campo requerido' }],
            color: [{ key: 'required', errorText: 'Campo requerido' }],
        }
    };
};



// WEBPACK FOOTER //
// ./forms/status.js